// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2c2lG","colBig":"styles_colBig__2cRlC","colSmall":"styles_colSmall__vkDCA"};